<script>
import professionalMixin from "@/mixins/accountable/professionalMixin";

export default {
  mixins: [professionalMixin],

  props: {
    professional: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <div class="sugestion">
    <h3>Com dúvida sobre quem escolher?</h3>

    <p>
      A profissional <span>{{ professional | firstName }}</span> é uma ótima escolha. Ela vem sendo muito procurada e tem recebido uma alta quantidade de agendamentos nas últimas semanas.
    </p>

    <slot name="card" />
  </div>
</template>

<style scoped>
.sugestion {
  position: relative;
  margin-top: 24px;
}

.sugestion:before {
  width: 200px;
  height: 2px;
  position: absolute;
  top: -8px;
  left: calc(50% - 100px);
  content: "";
  background: #603285;
}

h3 {
  padding-top: 12px;
}

p {
  font-size: 14px;
}

p > span {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Sugestion.vue